import {
  documentToReactComponents,
  Options,
} from '@contentful/rich-text-react-renderer';
import { BLOCKS, Document } from '@contentful/rich-text-types';

type Input = {
  /** Usp title to override title */
  uspTitle?: React.ReactNode;
  richTextDocument: Document;
};

/**
 * Render a rich text document from Contentful and it overrides the title if specified
 */
const renderDocument = ({
  richTextDocument,
  uspTitle,
}: Input): React.ReactNode => {
  const renderOptions: Options = {
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => {
        if (uspTitle) {
          return <h1>{uspTitle}</h1>;
        }
        return <h1>{children}</h1>;
      },
      [BLOCKS.HEADING_2]: (node, children) => {
        if (uspTitle) {
          return <h2>{uspTitle}</h2>;
        }
        return <h2>{children}</h2>;
      },
      [BLOCKS.HEADING_3]: (node, children) => {
        if (uspTitle) {
          return <h3>{uspTitle}</h3>;
        }
        return <h3>{children}</h3>;
      },
    },
  };
  return <>{documentToReactComponents(richTextDocument, renderOptions)}</>;
};

export default renderDocument;
